export class AuditSummaryResultRequest{
    public UserID:number = -1;
    public AuditID:number = -1;
    public LocationID:number = -1;
    public hasStart:boolean = false;
    public hasEnd:boolean = false;
    public StartDate:Date;
    public EndDate:Date;
    public IncludeSubLocations:boolean = false;
    public AuditName: string = "";
    public LocationName: string = "";
    public CampaignID:number = -1;
    public AuditTypeID:number = -1;
    public AuditFrequencyID:number = -1;
    public IsCampaign:boolean = false;
    public ExcludeEventResults:boolean = false;
    public PageNumber:number = 1;
    public PageSize:number = 25;
    public QuickSummaryContext: string = "";
    public DeepDivePrompt: string = "";
    constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}
